import { Box, Paper, Skeleton, Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const PairingSkeleton1 = () => {
  const COLS = 9;
  const ROWS = 10;
  const [searchParams] = useSearchParams();
  const pairingRowsNumber =
    searchParams.get("receipt_shared_uid")?.split(",").length || ROWS;

  return (
    <Paper sx={{ p: 2 }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Box>
          <Skeleton width={180} height={32} />
          <Skeleton width={320} height={18} />
        </Box>
        <Skeleton variant="rectangular" width={140} height={36} />
      </Box>

      {/* Table Header */}
      <Box
        display="grid"
        gridTemplateColumns="40px repeat(8, 1fr)"
        gap={1}
        mb={1}
      >
        {Array.from({ length: COLS }).map((_, i) => (
          <Skeleton key={i} height={20} />
        ))}
      </Box>

      {/* Table Rows */}
      {Array.from({ length: pairingRowsNumber }).map((_, rowIndex) => (
        <Box
          key={rowIndex}
          display="grid"
          gridTemplateColumns="40px repeat(8, 1fr)"
          gap={1}
          py={1}
          alignItems="center"
        >
          {/* Remove icon */}
          <Skeleton variant="circular" width={20} height={20} />

          {/* Cells */}
          <Skeleton height={20} />
          <Skeleton height={20} />
          <Skeleton height={20} />
          <Skeleton height={20} />

          {/* Status chip */}
          <Skeleton variant="rounded" width={80} height={24} />

          {/* FME add */}
          <Skeleton height={20} />

          {/* Credit / Debit */}
          <Skeleton height={20} />
          <Skeleton height={20} />
        </Box>
      ))}

      {/* Footer */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Skeleton width={80} height={20} />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
        <Skeleton width={120} height={20} />
      </Box>
    </Paper>
  );
};

export default PairingSkeleton1;
